<template>
  <div>
    <div class="border-bottom">등록된 스토리</div>
    <v-expansion-panels
        v-model="activeExpansionPanels"
        tile
        flat
        multiple
        accordion
    >
      <v-expansion-panel
          style="border-bottom: 1px solid #dbdbdb"
          :style="{'border-top': index === 0 ? '1px solid #dbdbdb' : false}"
          v-for="(story, index) in stories"
          :key="index"
      >
        <v-expansion-panel-header class="pa-0">
          <div
              :class="{'text-decoration-line-through' : !story.isActive,
              'font-weight-bold': story.isActive,
              'font-weight-normal': !story.isActive
              }"
          >{{ story.title }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <image-with-progress-circular
              v-if="!!story.imgUrl"
              :src="story.imgUrl"
              clazz="elevation-2"
          />
          <div class="mt-3 d-flex justify-space-between">
            <small>{{ fromServerTimestampToDate(story.createdAt) }}에 등록</small>
            <small v-if="story.isActive">전체공개</small>
            <small v-else>비공개</small>
          </div>
          <div
              class="mt-3 registered-description-text"
              style="word-wrap: break-word; white-space: pre-line"
          >
            {{ JSON.parse(story.description) }}
          </div>
          <div class="d-flex justify-space-between align-center mt-3">
            <v-btn
                width="180"
                outlined
                color="#dbdbdb"
                @click="updateStory(story)"
            >
              <div style="color: #000000">수정하기</div>
            </v-btn>
            <div class="d-flex justify-end align-center py-0">
              <v-icon
                  v-if="doNotShowStoryDeleteConfirmModal"
                  color="onuGreyColor"
                  @click="deleteStory(story.id, story.fullPath, index)"
              >
                {{ `mdi-delete-outline` }}
              </v-icon>
              <story-delete-confirm
                  v-else
                  @deleteStory="deleteStory(story.id, story.fullPath, index)"/>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import {collectionNames, simpleDelete, simpleReadByFieldOrderByAsc} from "@/firebase/firestore";
import timestampConverter from "../../mixins/converters";
import {deleteImg} from "@/firebase/firestorage";
import behavior from "../../constants/behavior";
import {EventBus} from "@/plugins/event-bus";
import StoryDeleteConfirm from "./StoryDeleteConfirm";
import ImageWithProgressCircular from "../Common/ImageWithProgressCircular";

export default {
  name: "StoriesRegistered",
  mixins: [timestampConverter],
  created() {
    const storeId = this.$store.getters.getStoreId
    simpleReadByFieldOrderByAsc(collectionNames.story, 'storeId', storeId, 'createdAt')
        .then(resultArr => {
          this.$store.commit(behavior.SET_STORIES, resultArr)
        })
  },
  mounted() {
    EventBus.$on(behavior.CLOSE_ACTIVE_EXPANSION_PANELS, () => {
      this.activeExpansionPanels = []
    })
  },
  components: {
    'story-delete-confirm': StoryDeleteConfirm,
    'image-with-progress-circular': ImageWithProgressCircular
  },
  computed: {
    stories() {
      return this.$store.state.stories
    },
    doNotShowStoryDeleteConfirmModal() {
      return this.$store.state.doNotShowStoryDeleteConfirmModal
    },
  },
  data: () => ({
    activeExpansionPanels: [],

  }),
  methods: {
    async deleteStory(id, fullPath, index) {
      try {
        await simpleDelete(collectionNames.story, id)
        await deleteImg(fullPath)
        this.$store.commit(behavior.DELETE_STORY, index)
        EventBus.$emit(behavior.OPEN_SNACK_BAR_PRIMARY, '해당 스토리가 삭제됐습니다.')
      } catch (e) {
        EventBus.$emit(behavior.OPEN_SNACK_BAR_ERROR, '스토리를 삭제하는 과정에서 오류가 발생했습니다.')
      }
      this.activeExpansionPanels = []
    },
    updateStory(story) {
      EventBus.$emit(behavior.UPDATE_STORY, {
        ...story, description: JSON.parse(story.description)
      })
    }
  }
}
</script>

<style scoped>
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0 0 12px 0 !important;
}

</style>